/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Request_Invalid_QueryInputs */

const en_us2_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That filter is not valid. Clear it and try again.`)
};

const pt_br2_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse filtro não é válido. Limpe e tente de novo.`)
};

const es_419_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese filtro no es válido. Bórralo e intenta de nuevo.`)
};

const pt_pt2_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse filtro não é válido. Limpa-o e tenta outra vez.`)
};

const fr_fr2_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce filtre n'est pas valide. Efface-le et réessaie.`)
};

const de_de2_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Filter ist ungültig. Entferne ihn und versuch es noch mal.`)
};

const it_it2_request_invalid_query = /** @type {(inputs: Request_Invalid_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo filtro non è valido. Rimuovilo e riprova.`)
};

/**
* | output |
* | --- |
* | "That filter is not valid. Clear it and try again." |
*
* @param {Request_Invalid_QueryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const request_invalid_query = /** @type {((inputs?: Request_Invalid_QueryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Request_Invalid_QueryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_request_invalid_query(inputs)
	if (locale === "es-419") return es_419_request_invalid_query(inputs)
	if (locale === "pt-PT") return pt_pt2_request_invalid_query(inputs)
	if (locale === "fr-FR") return fr_fr2_request_invalid_query(inputs)
	if (locale === "de-DE") return de_de2_request_invalid_query(inputs)
	if (locale === "it-IT") return it_it2_request_invalid_query(inputs)
	return en_us2_request_invalid_query(inputs)
});
export { request_invalid_query as "request.invalid_query" }